/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bo as Bo,
  rec_Componente_gDolar_103_36 as Componente_gDolar_103_36,
  rec_Componente_rDolar_114_36 as Componente_rDolar_114_36,
  rec_JSXRuntime as JSXRuntime,
  rec_MQ as MQ,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_a$ as a$,
} from "../../runtime/index.jsx";
export function ResumenCostos(e) {
  let t = (0, ReactCompiler.c)(32),
    { datos: n } = e,
    r;
  t[0] === n.areas
    ? (r = t[1])
    : ((r = Math.max(...n.areas.map(a$), 0)), (t[0] = n.areas), (t[1] = r));
  let i = r,
    a;
  t[2] === n.ordenes
    ? (a = t[3])
    : ((a = (
        <Componente_gDolar_103_36 etiqueta={`Órdenes`} valor={n.ordenes} />
      )),
      (t[2] = n.ordenes),
      (t[3] = a));
  let o;
  t[4] === n.costo
    ? (o = t[5])
    : ((o = MQ(n.costo)), (t[4] = n.costo), (t[5] = o));
  let s;
  t[6] === o
    ? (s = t[7])
    : ((s = <Componente_gDolar_103_36 etiqueta={`Servicio`} valor={o} />),
      (t[6] = o),
      (t[7] = s));
  let c;
  t[8] === n.penalidad
    ? (c = t[9])
    : ((c = MQ(n.penalidad)), (t[8] = n.penalidad), (t[9] = c));
  let l;
  t[10] === c
    ? (l = t[11])
    : ((l = <Componente_gDolar_103_36 etiqueta={`Penalidades`} valor={c} />),
      (t[10] = c),
      (t[11] = l));
  let u;
  t[12] === n.total
    ? (u = t[13])
    : ((u = MQ(n.total)), (t[12] = n.total), (t[13] = u));
  let d;
  t[14] === u
    ? (d = t[15])
    : ((d = <Componente_gDolar_103_36 etiqueta={`Total`} valor={u} />),
      (t[14] = u),
      (t[15] = d));
  let f;
  t[16] !== a || t[17] !== s || t[18] !== l || t[19] !== d
    ? ((f = (
        <div
          className={`grid grid-cols-2 gap-3 sm:grid-cols-4`}
          children={[a, s, l, d]}
        />
      )),
      (t[16] = a),
      (t[17] = s),
      (t[18] = l),
      (t[19] = d),
      (t[20] = f))
    : (f = t[20]);
  let p;
  t[21] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((p = (
        <thead
          className={`text-xs text-(--text)`}
          children={
            <tr
              className={`border-b border-(--border)`}
              children={[
                <th
                  className={`py-2 pl-3 pr-3 font-medium`}
                  children={`Área`}
                />,
                <th className={`py-2 pr-3 font-medium`} children={`Órdenes`} />,
                <th
                  className={`hidden py-2 pr-3 font-medium sm:table-cell`}
                  children={`Personas`}
                />,
                <th
                  className={`hidden py-2 pr-3 text-right font-medium sm:table-cell`}
                  children={`Servicio`}
                />,
                <th
                  className={`hidden py-2 pr-3 text-right font-medium sm:table-cell`}
                  children={`Penalidad`}
                />,
                <th
                  className={`py-2 pr-3 text-right font-medium`}
                  children={`Total`}
                />,
                <th className={`w-32 py-2 pr-3 font-medium`} children={`%`} />,
              ]}
            />
          }
        />
      )),
      (t[21] = p))
    : (p = t[21]);
  let m;
  if (t[22] !== n.areas || t[23] !== i) {
    let e;
    (t[25] === i
      ? (e = t[26])
      : ((e = (e) => (
          <tr
            key={e.area}
            className={`border-t border-(--border)/50`}
            children={[
              <td
                className={`py-1.5 pl-3 pr-3 text-(--text-h)`}
                children={e.area}
              />,
              <td
                className={`py-1.5 pr-3 text-(--text)`}
                children={e.ordenes}
              />,
              <td
                className={`hidden py-1.5 pr-3 text-(--text) sm:table-cell`}
                children={[
                  e.personas,
                  e.noViajaron > 0 && (
                    <span
                      className={`text-(--error)`}
                      children={[` (`, e.noViajaron, ` no viajaron)`]}
                    />
                  ),
                ]}
              />,
              <td
                className={`hidden py-1.5 pr-3 text-right text-(--text) sm:table-cell`}
                children={MQ(e.costo)}
              />,
              <td
                className={`hidden py-1.5 pr-3 text-right sm:table-cell`}
                children={
                  <span
                    className={
                      Number(e.penalidad) > 0
                        ? `text-(--error)`
                        : `text-(--text)`
                    }
                    children={MQ(e.penalidad)}
                  />
                }
              />,
              <td
                className={`py-1.5 pr-3 text-right font-medium whitespace-nowrap text-(--text-h)`}
                children={MQ(e.total)}
              />,
              <td
                className={`py-1.5 pr-3`}
                children={
                  <div
                    className={`flex items-center gap-2`}
                    children={[
                      <Componente_rDolar_114_36
                        parte={Number(e.total ?? 0)}
                        total={i}
                      />,
                      <span
                        className={`w-12 shrink-0 text-right text-xs text-(--text)`}
                        children={[Number(e.porcentaje).toFixed(1), `%`]}
                      />,
                    ]}
                  />
                }
              />,
            ]}
          />
        )),
        (t[25] = i),
        (t[26] = e)),
      (m = n.areas.map(e)),
      (t[22] = n.areas),
      (t[23] = i),
      (t[24] = m));
  } else m = t[24];
  let h;
  t[27] === m
    ? (h = t[28])
    : ((h = (
        <section
          className={`${Bo} p-0`}
          children={
            <div
              className={`overflow-x-auto`}
              children={
                <table
                  className={`w-full text-left text-sm`}
                  children={[p, <tbody children={m} />]}
                />
              }
            />
          }
        />
      )),
      (t[27] = m),
      (t[28] = h));
  let _;
  return (
    t[29] !== h || t[30] !== f
      ? ((_ = <div className={`flex flex-col gap-4`} children={[f, h]} />),
        (t[29] = h),
        (t[30] = f),
        (t[31] = _))
      : (_ = t[31]),
    _
  );
}
